import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink, To } from 'react-router'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { Button } from '@mui/material'

import { TEXT_BUTTON_SX } from './styles'

const BACK_LINK_SX = {
  ...TEXT_BUTTON_SX,
  // The old link is in capitals. In the new theme it reads as normal text.
  textTransform: 'none',
  fontWeight: 600,
}

type ThemedBackLinkProps = {
  /** The link text. Defaults to "Back To Policies". */
  label?: string
} & (
  { to: To; state?: unknown; onClick?: never } | { onClick: () => void; to?: never; state?: never }
)

/**
 * "Back To Policies" above the policy name. With `to` it is a link. With `onClick` it is a
 * button: the edit page asks first if the user wants to leave the changes. The Compliance
 * details page gives its own `label`.
 */
export const ThemedBackLink: FC<ThemedBackLinkProps> = ({ to, state, onClick, label }) => {
  const { t } = useTranslation()
  const text = label ?? t('policiesLibrary.backToPolicies', 'Back To Policies')

  if (to !== undefined)
    return (
      <Button
        component={RouterLink}
        to={to}
        state={state}
        size="small"
        startIcon={<ChevronLeftIcon />}
        sx={BACK_LINK_SX}
      >
        {text}
      </Button>
    )

  return (
    <Button onClick={onClick} size="small" startIcon={<ChevronLeftIcon />} sx={BACK_LINK_SX}>
      {text}
    </Button>
  )
}
